/** 필터가 아닌 예약된 쿼리 파라미터의 기본값 */ const DEFAULT_RESERVED_PARAMS = [
    "id",
    "page",
    "sort"
];
/** URL에서 필터 파라미터 파싱 (예약된 파라미터 제외한 모든 파라미터를 필터로 처리) */ export const parseFiltersFromQuery = function(query) {
    let reservedParams = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_RESERVED_PARAMS;
    const filters = {};
    Object.entries(query).forEach((param)=>{
        let [key, value] = param;
        if (reservedParams.includes(key)) return;
        if (value) {
            filters[key] = typeof value === "string" ? value.split(",") : value;
        }
    });
    return filters;
};
/** 필터를 URL 쿼리로 변환 */ export const filtersToQuery = (filters)=>{
    const query = {};
    Object.entries(filters).forEach((param)=>{
        let [key, values] = param;
        if (values.length > 0) {
            query[key] = values.join(",");
        } else {
            query[key] = undefined;
        }
    });
    return query;
};
